import api from "../lib/api";

export const teamMemberService = {
    getPermissions: () => api.get('/company/permissions/grouped'),
    getTeamMembers: () => api.get('/company/team-members'),
    createTeamMember: (data) => api.post('/company/team-members', data),
    updateTeamMember: (id, data) => api.put(`/company/team-members/${id}`, data),
    deleteTeamMember: (id) => api.delete(`/company/team-members/${id}`),
};